import FormPageTemplate from '../forms/FormPageTemplate'

const ConcreteLandingForm = () => {
    const landingData = {
        title: "Luxury Concrete & Turf Design.",
        subtitle: "Low maintenance, high impact. We design and build driveways, patios, and outdoor surfaces tailored to South Florida conditions — durable, code-compliant, and built to last."
    }
    
    return (
        <FormPageTemplate
            title="GET YOUR CONCRETE/TURF QUOTE NOW!"
            subtitle={landingData.title}
            defaultFormType="construction_new_project"
            returnPath="/landing-concrete"
            initialPreselect={{ type: '1', desc: 'Concrete' }}
            thankYouPath="/landing-concrete-form/thank-you"
        />
    )
}

export default ConcreteLandingForm
